
import { applyPromoCode } from '@/helpers/PromoCodes'
import { reportFormValidity } from '@/helpers/Validation'
import store from '@/store/store'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { promoCodeErrorMessage } from '@/helpers/PromoCodesHelper'

@Component({ name: 'ApplyPromoCodes' })
export default class extends Vue {
  @Prop({ default: false })
  submitDisabled: boolean

  rawValue: string = ''
  applying: boolean = false
  error: string | null = null

  readonly minLength = 2

  get totalPromoDiscounts() {
    return store.getters['Cart/totalPromoDiscounts']
  }

  get value() {
    return this.rawValue.trim()
  }

  apply() {
    this.applying = true
    this.error = null
    reportFormValidity(this.$refs.form as HTMLFormElement)
      .then(() => applyPromoCode(this.value))
      .then(() => {
        this.rawValue = ''
      })
      .catch((error) => {
        const input = this.$refs.input as HTMLInputElement
        this.error = promoCodeErrorMessage(this.value, error, input)
        // TODO: Focus input on error

        if (this.error === this.$t('applyPromoCodes.unknownErrorMessage')) {
          throw error
        }
      })
      .finally(() => {
        // Reset state.
        this.applying = false
      })
  }

  reset() {
    this.error = null
    this.rawValue = ''
  }
}
